module.exports = __webpack_public_path__ + "img/met-logo.f0914652.svg";